const LoadMore = {
    bindEvents: () => {
        const loadMore = document.getElementsByClassName('loadmore-control');
        if (loadMore.length) {
            console.log('Load More Init')
            LoadMore.init(loadMore);
        }
    },
    init: (loadMoreControls) => {
        for (let i = 0; i < loadMoreControls.length; i++) {
            let loadMore = loadMoreControls[i];
            let itemClass = loadMore.hasAttribute('data-item') ? loadMore.getAttribute('data-item') : 'sib-card';
            let perPage = loadMore.hasAttribute('data-perpage') ? parseInt(loadMore.getAttribute('data-perpage')) : 3;
            let dataFilter = loadMore.hasAttribute('data-filterId') ? loadMore.getAttribute('data-filterId') : false;
            let items = loadMore.getElementsByClassName(itemClass);
            let cloneItems = loadMore.getElementsByClassName('sib-card-clone');
            let loadMoreStatus = loadMore.getElementsByClassName('loadmore-control--status');
            // init filter
            if (dataFilter) {
                let filters = document.getElementById(dataFilter);
                if (filters) {
                    LoadMore.initFilter(loadMore, filters, items, loadMoreStatus);
                }
            }
            console.log('Load More itemClass', itemClass)
            console.log('Load More Items', items)
            console.log('Load More Status', loadMoreStatus)
            if (loadMoreStatus.length && perPage < items.length) {
                let loadMoreButton = loadMoreStatus[0].getElementsByClassName('loadmore-control--button');
                if (loadMoreButton.length) {
                    // add event listener for 'Load More' button click
                    loadMoreButton[0].addEventListener('click', () => {
                        console.log('Load More Pressed')
                        let showCounter = 0;
                        let displayed = 0;
                        for (let j = 0; j < items.length; j++) {
                            if (showCounter < perPage && items[j].classList.contains('hidden')) {
                                items[j].classList.remove('hidden');
                                showCounter++;
                            }
                            if (!items[j].classList.contains('hidden') && !items[j].classList.contains('sib-card-clone')) {
                                displayed++;
                            }
                        }
                        // Update loadmore status
                        let displayCount = loadMoreStatus[0].getElementsByClassName('loadmore-control--total');
                        if (displayCount.length) {
                            displayCount[0].innerHTML = displayed;
                        }
                        // Hide loadmore button upon completion
                        if (displayed >= (items.length - cloneItems.length)) {
                            loadMoreButton[0].classList.add('hidden');
                        }
                    });
                }
            }
        }
    },
    initFilter: (loadMore, filters, items, loadMoreStatus) => {
        const filterButtons = filters.getElementsByClassName('loadmore-filter--button');
        for (let i = 0; i < filterButtons.length; i++) {
            filterButtons[i].addEventListener('click', (e) => {
                e.preventDefault();
                for (let j = 0; j < filterButtons.length; j++) {
                    if (i !== j) {
                        filterButtons[j].classList.remove('active');
                    }
                }
                filterButtons[i].classList.toggle('active');
                LoadMore.filter(
                    filterButtons[i].classList.contains('active'),
                    filterButtons[i].getAttribute('data-filter-type'),
                    items,
                    loadMoreStatus
                );
            });
        }
    },
    filter: (filterItems, filterKeyword, items, loadMoreStatus) => {
        // remove loadmore functionality upon filter request
        let displayed = 0;
        for (let i = 0; i < items.length; i++) {
            items[i].classList.add('hidden');
            if (filterItems) {
                if (items[i].hasAttribute('data-filter')) {
                    let filter = items[i].getAttribute('data-filter');
                    // search filter
                    if (filter.indexOf(filterKeyword) !== -1) {
                        items[i].classList.remove('hidden');
                        displayed++;
                    }
                }
            } else {
                // remove filter
                items[i].classList.remove('hidden');
                displayed++;
            }
        }
        if (loadMoreStatus.length) {
            if (filterItems) {
                loadMoreStatus[0].classList.add('hidden');
            } else {
                let displayCount = loadMoreStatus[0].getElementsByClassName('loadmore-control--total');
                if (displayCount.length) {
                    displayCount[0].innerHTML = displayed;
                }
                let loadMoreButton = loadMoreStatus[0].getElementsByClassName('loadmore-control--button');
                loadMoreButton[0].classList.add('hidden');
                loadMoreStatus[0].classList.remove('hidden');
            }
        }
    },
};

module.exports = LoadMore;



// WEBPACK FOOTER //
// ./src/js/partials/loadmore.js